// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"0531f327","324":"ce5b381c","534":"2acfb803","698":"675b4bf2"}[chunkId] + ".chunk.js";
};